import { useState, useEffect } from 'react';

/**
 * Debounces a value by a given delay.
 * Returns the debounced value that only updates after the specified delay
 * has passed since the last change to the input value.
 */
export function useDebounce<T>(value: T, delay: number = 400): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(timer);
    };
  }, [value, delay]);

  return debouncedValue;
}
